module.exports = {
      id: "fb-blue-usage",
      viewBox: "0 0 28 27.83",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#fb-blue",
      toString: function () {
        return this.url;
      }
    }